export const PLATFORM_COST_METRICS_API_PATH =
  'v1/reports/metrics/platform-costs'

export const PLATFORM_COST_REPORT_TYPE = 'platform_cost_metrics' as const

export const PLATFORM_COST_METRICS_ROUTE = '/platform-cost-metrics' as const

/** Matches Dashboard/Orders: period chips default to Today when the URL has no filter. */
export const PLATFORM_COST_DEFAULT_PERIOD = 'today' as const

/** Inclusive start used when resolving the inception_to_date preset for metrics GET. */
export const PLATFORM_COST_INCEPTION_START_DATE = '2020-01-01' as const

export const PLATFORM_COST_BUCKET = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
} as const

export const PLATFORM_COST_BUCKET_LABEL = {
  [PLATFORM_COST_BUCKET.DAY]: 'Day',
  [PLATFORM_COST_BUCKET.WEEK]: 'Week',
  [PLATFORM_COST_BUCKET.MONTH]: 'Month',
} as const

export const PLATFORM_COST_METRIC_KEY = {
  TOTAL_DISCOUNTS: 'totalDiscounts',
  TOTAL_DELIVERY_CHARGES: 'totalDeliveryCharges',
  TOTAL_PAYMENT_PROVIDER_FEES: 'totalPaymentProviderFees',
  TOTAL_REFERRAL_SETTLEMENTS: 'totalReferralSettlements',
  TOTAL_AFFILIATE_SETTLEMENTS: 'totalAffiliateSettlements',
  TOTAL_AMBASSADOR_SETTLEMENTS: 'totalAmbassadorSettlements',
} as const

export const PLATFORM_COST_METRIC_LABEL = {
  [PLATFORM_COST_METRIC_KEY.TOTAL_DISCOUNTS]: 'Discounts',
  [PLATFORM_COST_METRIC_KEY.TOTAL_DELIVERY_CHARGES]: 'Delivery Charges',
  [PLATFORM_COST_METRIC_KEY.TOTAL_PAYMENT_PROVIDER_FEES]:
    'Payment Provider Fees',
  [PLATFORM_COST_METRIC_KEY.TOTAL_REFERRAL_SETTLEMENTS]: 'Referral Settlements',
  [PLATFORM_COST_METRIC_KEY.TOTAL_AFFILIATE_SETTLEMENTS]:
    'Affiliate Settlements',
  [PLATFORM_COST_METRIC_KEY.TOTAL_AMBASSADOR_SETTLEMENTS]:
    'Ambassador Settlements',
} as const

export const PLATFORM_COST_METRIC_KEYS = [
  PLATFORM_COST_METRIC_KEY.TOTAL_DISCOUNTS,
  PLATFORM_COST_METRIC_KEY.TOTAL_DELIVERY_CHARGES,
  PLATFORM_COST_METRIC_KEY.TOTAL_PAYMENT_PROVIDER_FEES,
  PLATFORM_COST_METRIC_KEY.TOTAL_REFERRAL_SETTLEMENTS,
  PLATFORM_COST_METRIC_KEY.TOTAL_AFFILIATE_SETTLEMENTS,
  PLATFORM_COST_METRIC_KEY.TOTAL_AMBASSADOR_SETTLEMENTS,
] as const

export const PLATFORM_COST_MESSAGE = {
  LOAD_ERROR: 'Unable to load platform cost metrics.',
  UNRESOLVED_DATE_RANGE:
    'Choose a valid date range to load platform cost metrics.',
  INVALID_DATE_RANGE: 'End date must be on or after the start date.',
  SELECT_METRIC_TITLE: 'Select a cost',
  SELECT_METRIC: 'Select a cost above to explore its trend.',
} as const
